"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var BaseCollectionQuery_1 = require("./BaseCollectionQuery");
var Query_1 = require("./Query");
var HistoricalDatasetsQuery = /** @class */ (function (_super) {
    __extends(HistoricalDatasetsQuery, _super);
    function HistoricalDatasetsQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HistoricalDatasetsQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    HistoricalDatasetsQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, entityType = _a.entityType, code = _a.code, codeQuery = _a.codeQuery, key = _a.key, keyQuery = _a.keyQuery, extendedKey = _a.extendedKey, collectionItemConditional = _a.collectionItemConditional, fields = _a.fields, sort = _a.sort, index = _a.index, startIndex = _a.startIndex, endIndex = _a.endIndex, entityKey = _a.entityKey, entityIndex = _a.entityIndex, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ entityType: entityType,
            code: code,
            codeQuery: codeQuery,
            key: key,
            keyQuery: keyQuery,
            collectionItemConditional: collectionItemConditional,
            fields: fields,
            sort: sort,
            index: index,
            startIndex: startIndex,
            endIndex: endIndex,
            entityKey: entityKey,
            entityIndex: entityIndex }, (options.historicalDatasets || {}));
    };
    HistoricalDatasetsQuery.prototype.getRawValue = function (executionOptions) {
        var _this = this;
        var _a = this.options, sort = _a.sort, index = _a.index, startIndex = _a.startIndex, endIndex = _a.endIndex;
        return this.processEntities(executionOptions, function (entity) {
            if (entity && entity.historicalDatasets) {
                var historicalDatasets = _this.getHistoricalDatasets(executionOptions);
                if (sort) {
                    historicalDatasets = _this.applySort(historicalDatasets, sort, undefined, executionOptions.inputs);
                }
                var result = historicalDatasets && historicalDatasets.map(function (historicalDataset) { return _this.getHistoricalDatasetResult(executionOptions, historicalDataset); });
                result = result.slice(startIndex, endIndex);
                if (result && result.length > 0) {
                    if (typeof index === 'number') {
                        var targetIndex = _this.getIndex(index, result);
                        if (targetIndex > -1) {
                            var item = result[targetIndex];
                            return item;
                        }
                    }
                    else {
                        return result;
                    }
                }
                // if (index > -1 && result.length > index) {
                // 	return result[index];
                // }
                return result;
            }
        });
    };
    HistoricalDatasetsQuery.prototype.getHistoricalDatasets = function (executionOptions) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var _a = this.options, code = _a.code, asAtDate = _a.asAtDate, asAtDateStart = _a.asAtDateStart, asAtDateEnd = _a.asAtDateEnd, _b = _a.collectionItemConditional, collectionItemConditional = _b === void 0 ? { conditions: [] } : _b;
        if (code && !collectionItemConditional.conditions.find(function (condition) { return condition.field === 'code'; })) {
            collectionItemConditional.conditions.push({
                field: 'code',
                operator: '=',
                value: code,
            });
        }
        if (asAtDate && !collectionItemConditional.conditions.find(function (condition) { return condition.field === 'asAtDate'; })) {
            collectionItemConditional.conditions.push({
                field: 'asAtDate',
                operator: '=',
                value: asAtDate,
            });
        }
        if (asAtDateStart && asAtDateEnd && !collectionItemConditional.conditions.find(function (condition) { return condition.field === 'asAtDate'; })) {
            collectionItemConditional.conditions.push({
                field: 'asAtDate',
                operator: '>=',
                value: asAtDateStart,
            });
            collectionItemConditional.conditions.push({
                field: 'asAtDate',
                operator: '<=',
                value: asAtDateEnd,
            });
        }
        var collectionItems = this.getSubCollection(executionOptions)
            .filter(function (item) { return conditionalHelper.matches(item, collectionItemConditional, executionOptions); });
        return collectionItems;
    };
    HistoricalDatasetsQuery.prototype.getHistoricalDatasetResult = function (executionOptions, historicalDataset) {
        var _a = this.options, fields = _a.fields, childKey = _a.childKey, childIndex = _a.childIndex;
        if (!fields || fields.length === 0) {
            var key = this.options.key;
            return this.getHistoricalDatasetValue(executionOptions, historicalDataset, key, childKey, childIndex);
        }
        var historicalDatasetResult = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            var name_1 = field.name, key = field.key, childKey_1 = field.childKey, childIndex_1 = field.childIndex, query = field.query;
            historicalDatasetResult[name_1] = this.getHistoricalDatasetValue(executionOptions, historicalDataset, key, childKey_1, childIndex_1, query);
        }
        return historicalDatasetResult;
    };
    HistoricalDatasetsQuery.prototype.getHistoricalDatasetValue = function (executionOptions, historicalDataset, key, childKey, childIndex, query) {
        if (key === void 0) { key = null; }
        if (childKey === void 0) { childKey = null; }
        if (childIndex === void 0) { childIndex = -1; }
        if (historicalDataset) {
            if (!key && query) {
                var fieldQuery = new Query_1.Query(query);
                return fieldQuery.execute(__assign(__assign({}, executionOptions), { responseContext: historicalDataset }));
            }
            else if (key === 'values') {
                var values = historicalDataset.values;
                if (query) {
                    var fieldQuery = new Query_1.Query(query);
                    values = fieldQuery.execute(__assign(__assign({}, executionOptions), { responseContext: values }));
                }
                if (childIndex > -1) {
                    if (values.length > childIndex) {
                        if (childKey) {
                            return values[childIndex][childKey];
                        }
                        return values[childIndex];
                    }
                    else {
                        return;
                    }
                }
                if (childKey) {
                    return values.map(function (v) { return v[childKey]; });
                }
                return values;
            }
            if (key) {
                return historicalDataset[key];
            }
            return historicalDataset;
        }
        return;
    };
    return HistoricalDatasetsQuery;
}(BaseCollectionQuery_1.BaseCollectionQuery));
exports.HistoricalDatasetsQuery = HistoricalDatasetsQuery;
//# sourceMappingURL=HistoricalDatasetsQuery.js.map